/* Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Text Fields and Buttons
Suresh Peddavoora 10/31/2022 3075154998  Changed  Class Name for Text Fields
Ravi    11/02/2022 3075154998 Fixed prepopulation reset data
Lalitha 11/9/2022  3075154998 Rename Button Clear to Reset
Prakash Gummala 11/10/2022 3075154998 Text Field Alignments for Desktop Resolution
*/

import React, {useEffect, useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import {Resetdata as resetdata} from '../../../../../redux/reducers/DataManagerFilter';
import SearchDataManagerFilterTable from './SearchDataManagerFilterTable';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {
  SuccessSnackbar,
  ErrorSnackbar,
  WarningSnackbar,
} from '../../../../../components/CustomSnackBar';
import * as Yup from 'yup';

const SearchDataManagerFilterContainer = ({
  setValueCode,
  setTabValue,
  setFilterCode,
  setFilterCodeName,
  setIsCopyRowData,
  setUsageState,
  setFieldRowData,
  fieldRowData,
}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState([]);
  const [submit, setSubmit] = useState(false);
  // const [customError, setCustomError] = useState(false);
  const customError = false;
  const [isDelete, setIsDelete] = useState(false);
  const {isLoading, successMsg, errorMsg} = useSelector(
    ({filter}) => filter,
  );
  const schema = Yup.object().shape({
    name: Yup.string().matches(
      /^[a-zA-Z0-9]+$/,
      'White space and special character are not allowed',
    ),
  });

  const initialValues = {
    name: '',
    description: '',
  };

  const onClear = () => {
    const data = {
      name: '',
      description: '',
    };
    setSearchData(data);
  };

  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };


  useEffect(() => {
    // setFilterCode("");
    // setFilterCodeName("");
    dispatch(resetdata());
  }, []);

  return (
    <>
      <div className={`mb-0`}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {touched, errors, values, handleChange, handleBlur, handleReset} = props;
            return (
              <div className="standard-field-textfields">
                <Form autoComplete="off" noValidate>
                  <Grid container spacing={2}>
                    <Grid item xs={3} md={4} sm={6} xl={3} className="form-group">
                      <TextField
                        margin="dense"
                        variant="standard"
                        placeholder={`Enter Filter Code`}
                        label="Filter Code"
                        name="name"
                        value={values?.name?.toUpperCase()}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.name}
                        error={Boolean(touched.name && errors.name)}
                      />
                      <FormHelperText>{touched.name && errors.name && errors.name} </FormHelperText>
                    </Grid>
                    <Grid item xs={3} md={4} sm={6} xl={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="standard"
                        name="description"
                        placeholder={`Enter Description`}
                        label="Description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={3} md={4} sm={6} xl={4} className="form-group">
                      <div>
                        <Button
                          variant="outlined"
                          className={`reset-btn mx-1 ${classes.buttonRoot}`}
                          onClick={() => {
                            handleReset();
                            setSearchData({});
                            setSubmit(true);
                            onClear();
                          }}
                        >
                    Reset
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          className={`search-btn mx-1 ${classes.buttonRoot}`}
                        >
                    Search
                        </Button>
                      </div>
                    </Grid>
                  </Grid>

                </Form>
              </div>
            );
          }}
        </Formik>
        <Grid>
          <SearchDataManagerFilterTable
            setTabValue={setTabValue}
            searchData={searchData}
            setFilterCode={setFilterCode}
            setValueCode={setValueCode}
            setFilterCodeName={setFilterCodeName}
            submit={submit}
            setSubmit={setSubmit}
            // setIsCopyRowData={setIsCopyRowData}
            // setUsageState={setUsageState}
            isLoading={isLoading}
            // userMetrixDelete={userMetrixDelete}
            isDelete={isDelete}
            setIsDelete={setIsDelete}
            // deleteUsage={deleteUsage}
            // setDeleteUsage={setDeleteUsage}
            fieldRowData={fieldRowData}
            setFieldRowData={setFieldRowData}
            // isUsage={isUsage}
            // setIsUsage={setIsUsage}
          />
        </Grid>
        {customError && (
          <WarningSnackbar errorMsg={'This logic block is not being used anywhere'} />
        )}
      </div>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};
export default SearchDataManagerFilterContainer;
